<template>
  <div class="ai-dialog-header flex items-start gap-2.5">
    <div
      class="ai-dialog-header__icon flex items-center justify-center shrink-0"
    >
      <svg-icon name="huge-ai" class="w-4 h-4 fill-none" />
    </div>
    <div class="flex-1 min-w-0">
      <h2 class="ai-dialog-header__title truncate">
        {{ $t("AI-проверка пакета документов") }} · № {{ caseId }}
      </h2>
      <p class="ai-dialog-header__subtitle">{{ subtitleText }}</p>
    </div>
    <Tag
      v-if="state === 'running' || state === 'triggering'"
      variant="primary"
      size="xs"
      class="hidden sm:flex rounded uppercase !bg-indigo-50/60 !border-indigo-200 !text-indigo-600"
    >
      <div class="w-1 h-1 rounded-full bg-indigo-500 ai-blink"></div>
      {{ $t("Сканирование") }}
    </Tag>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Tag } from "@/shared/ui/tag";

const { t } = useI18n();

const props = defineProps({
  caseId: { type: String, default: "" },
  state: { type: String, default: "done" },
  progress: { type: Number, default: 0 },
  docCount: { type: Number, default: 0 },
});

function pluralDocs(n) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return t("документ");
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
    return t("документа");
  return t("документов");
}

const subtitleText = computed(() => {
  if (props.state === "unchecked" || props.state === "idle") {
    return `${props.docCount} ${pluralDocs(props.docCount)} · ${t(
      "ожидание запуска"
    )}`;
  }
  if (props.state === "triggering") {
    return t("Отправляем документы в сервис");
  }
  if (props.state === "running") {
    return `${t("Идёт анализ")} · ${props.progress}%`;
  }
  if (props.state === "stale") {
    return t("Загружены новые документы — рекомендуем перепроверку");
  }
  if (props.state === "error") {
    return t("Сервис AI временно недоступен");
  }
  return t("Рекомендуем перепроверять важную информацию");
});
</script>

<style lang="scss" scoped>
.ai-dialog-header {
  @apply border-0 border-b border-solid border-border bg-muted/30;
  padding: 14px 48px 14px 14px;

  &__icon {
    width: 30px;
    height: 30px;
    @apply rounded border border-solid border-indigo-100 bg-indigo-50;
    color: rgb(var(--color-indigo-500));
  }

  &__title {
    @apply font-semibold;
    font-size: 14px;
    letter-spacing: -0.005em;
    color: rgb(var(--color-gray-700));
    margin: 0;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 12px;
    color: rgb(var(--color-gray-500));
    margin: 2px 0 0 0;
    line-height: 1.4;
  }
}

.ai-blink {
  animation: ai-header-blink 1s ease-in-out infinite;
}

@keyframes ai-header-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}
</style>
